import { render, staticRenderFns } from "./examen.vue?vue&type=template&id=65f14c29&"
import script from "./examen.vue?vue&type=script&lang=js&"
export * from "./examen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports